import { kea } from "kea";
import api from '../utils/api';

import grouplogic from "./group";
import vehiclelogic from "./vehicle";
import profilelogic from "./profile";
import checkRole from "src/utils/checkRole";

export const alertlogic = kea({
	actions: {
		create: (alert) => ({ alert }),
		fetchAll: true,
		add_many: (alert, vehicles) => ({ alert, vehicles }),
		add_one: (alert, vehicle) => ({ alert, vehicle }),
		remove_one: (alert, vehicle) => ({ alert, vehicle }),
		update: (alert) => ({ alert }),
		remove: (alert) => ({ alert }),
		updateGroup: (alert) => ({ alert }),

		setAll: (alerts) => ({ alerts }),
		setOne: (alert) => ({ alert }),
		addOne: (alert) => ({ alert }),
		removeOne: (alert) => ({ alert }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		alerts: [null, {
			setAll: (_, { alerts }) => alerts,
			setOne: (state, { alert }) => state.map((s) => s._id === alert._id ? alert : s),
			addOne: (state, { alert }) => [...state, alert],
			removeOne: (state, { alert }) => state.filter((s) => alert._id !== s._id),
		}],
		loading: [false, {
			create: () => true,
			fetchAll: () => true,
			add_many: () => true,
			add_one: () => true,
			remove_one: () => true,
			update: () => true,
			remove: () => true,
			updateGroup: () => true,

			setAll: () => false,
			setOne: () => false,
			addOne: () => false,
			removeOne: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			setAll: () => null,
			setOne: () => null,
			addOne: () => null,
			removeOne: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		create: async ({ alert }, breakpoint) => {
			await breakpoint(300);
			let url = '/alert';
			let res;
			try {
				res = await api({ url, method: 'post', body: alert });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.addOne(json.payload);
				actions.setSuccess('Alert Created.');
			} else actions.setError(json.error);
		},
		fetchAll: async (_, breakpoint) => {
			await breakpoint(300)
			let url = '/alert';
			let res;
			try {
				res = await api({ url });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.setAll(json.payload);
			else actions.setError(json.error);
		},
		add_many: async ({ alert, vehicles }, breakpoint) => {
			await breakpoint(300);
			let url = `/alert/${alert}/add_many`;
			let res;
			try {
				res = await api({ url, method: 'put', body: { vehicles } });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				if (checkRole(profilelogic.values.profile, ['Admin'])) actions.fetchAll();
				if (checkRole(profilelogic.values.profile, ['VehicleView'])) vehiclelogic.actions.fetchAll();
				actions.setSuccess('Vehicle Added.');
			} else actions.setError(json.error);
		},
		add_one: async ({ alert, vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/alert/${alert}/add_one/${vehicle}`;
			let res;
			try {
				res = await api({ url, method: 'put' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				if (checkRole(profilelogic.values.profile, ['Admin'])) actions.fetchAll();
				if (checkRole(profilelogic.values.profile, ['VehicleView'])) vehiclelogic.actions.fetchAll();
				actions.setSuccess('Vehicle Added.');
			} else actions.setError(json.error);
		},
		remove_one: async ({ alert, vehicle }, breakpoint) => {
			await breakpoint(300);
			let url = `/alert/${alert}/remove_one/${vehicle}`;
			let res;
			try {
				res = await api({ url, method: 'delete' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				if (checkRole(profilelogic.values.profile, ['VehicleView'])) vehiclelogic.actions.fetchAll();
				actions.setSuccess('Vehicle Removed.');
			} else actions.setError(json.error);
		},
		update: async ({ alert }, breakpoint) => {
			await breakpoint(300);
			let url = `/alert/${alert._id}`;
			let res;
			try {
				res = await api({ url, method: 'put', body: alert });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				if (checkRole(profilelogic.values.profile, ['VehicleView'])) vehiclelogic.actions.fetchAll();
				actions.setSuccess('Alert Updated.');
			} else actions.setError(json.error);
		},
		remove: async ({ alert }, breakpoint) => {
			await breakpoint(300);
			let url = `/alert/${alert._id}`;
			let res;
			try {
				res = await api({ url, method: 'delete' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.removeOne(alert)
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				vehiclelogic.actions.fetchAll();
				actions.setSuccess('Alert Removed.');
			} else actions.setError(json.error);
		},
		updateGroup: async ({ alert }, breakpoint) => {
			await breakpoint(300);
			let url = `/alert/${alert._id}/group`;
			let res;
			try {
				res = await api({ url, method: 'put', body: alert });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				actions.setSuccess('Alert Updated.');
			} else actions.setError(json.error);
		}
	})
});

export default alertlogic;